import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { RtUICommonModule } from './../../../common/common.module';
import { AttachmentItemModule } from './../attachment-item/attachment-item.module';
import { FileUploadComponent } from './file-upload.component';

@NgModule({
  declarations: [FileUploadComponent],
  exports: [FileUploadComponent],
  imports: [AttachmentItemModule, CommonModule, RtUICommonModule],
})
export class FileUploadModule {}
export { FileUploadComponent } from './file-upload.component';
